"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _vehicleSelection = require("../actions/vehicleSelection");

var initialState = {
  availableBrands: {},
  availableModels: {},
  availableTypes: {},
  brandId: null,
  modelId: null,
  typeId: null,
  brand: "",
  model: "",
  type: ""
};

var vehicleSelection = function vehicleSelection() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _vehicleSelection.SELECT_BRAND:
      return _extends({}, state, {
        brandId: action.brandId,
        modelId: null,
        typeId: null,
        availableModels: {},
        availableTypes: {},
        brand: state.availableBrands[action.brandId].Value
      });

    case _vehicleSelection.SELECT_MODEL:
      return _extends({}, state, {
        modelId: action.modelId,
        typeId: null,
        availableTypes: {},
        model: state.availableModels[action.modelId].Value
      });

    case _vehicleSelection.SELECT_TYPE:
      return _extends({}, state, {
        typeId: action.typeId,
        type: state.availableTypes[action.typeId].Value
      });

    case _vehicleSelection.BRANDS_SUCCESS:
      var availableBrands = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = action.data.Vehicles.Brands[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var brand = _step.value;
          availableBrands[brand.Id] = brand;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return _extends({}, state, {
        availableBrands: availableBrands
      });

    case _vehicleSelection.MODELS_SUCCESS:
      var availableModels = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = action.data.Vehicles.Brands[0].Models[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var type = _step2.value;
          availableModels[type.Id] = type;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return _extends({}, state, {
        availableModels: availableModels
      });

    case _vehicleSelection.TYPES_SUCCESS:
      var availableTypes = {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = action.data.Vehicles.Brands[0].Models[0].Types[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _type = _step3.value;
          availableTypes[_type.Id] = _type;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return _extends({}, state, {
        availableTypes: availableTypes
      });

    default:
      return state;
  }
};

exports.default = vehicleSelection;